<template>
  <path
    :d="d"
    :fill="color"
  ></path>
</template>

<script>
import { arc } from 'd3-shape'
export default {
  name: 'Arc',
  props: {
    value: {
      type: Object,
      default () { return {} }
    },
    color: {
      type: String,
      default: '#666666'
    },
    outerRadius: {
      type: Number,
      default: 200
    },
    innerRadius: {
      type: Number,
      default: 0
    }
  },
  computed: {
    d () {
      return arc()
        .outerRadius(this.outerRadius)
        .innerRadius(this.innerRadius)(this.value)
    }
  }
}
</script>

<style>

</style>
